import { RMRectangle } from 'business/models/CustomModels';
import { IScoresOfWellDropsDTO } from 'business/models/Models';
import ScoreViewWell from 'components/plateviewer/plate/ScoreViewWell';
import { compareWithScoreGroupId } from 'utils/Global';
import React from 'react';
import { RMSvgIconImage } from 'components/customComponents/CommonComponents/RMSvgIcon';

interface Props {
  rect: RMRectangle;
  scores: IScoresOfWellDropsDTO[];
}
const disputeIcon = RMSvgIconImage({ name: 'DisputeScoreIcon' });
const widthPerofRect = 0.125;
const ScoreRenderer = (props: Props) => {
  const { scores, rect } = props;

  const autoScoresOfWellDrops = scores.filter((score) => score.isAutoScore === true);
  const manualScoresOfWellDrops = scores.filter((score) => score.isAutoScore === false);
  const sortedManualScores = manualScoresOfWellDrops.sort(compareWithScoreGroupId);
  const sortedAutoScores = autoScoresOfWellDrops.sort(compareWithScoreGroupId);
  let sortedWellDropScores = [...sortedManualScores, ...sortedAutoScores];
  if (rect.w * widthPerofRect * scores.length > rect.w) {
    const maxNoOScores = rect.w / (rect.w * widthPerofRect);
    sortedWellDropScores = sortedWellDropScores.slice(0, maxNoOScores);
  }

    return (
        <ScoreViewWell
            id={'score-viewwell'}
            x={rect.x}
            y={rect.y}
            icon={disputeIcon}
            width={rect.w}
            height={rect.h}
            scoresOfWellDrops={sortedWellDropScores}
            scale={1} //this might come from props
        />
    )
};

export default ScoreRenderer;
